(function () {
  'use strict';

  var root = document.querySelector('[data-gc-qo]');
  if (!root) { return; }

  var results = root.querySelector('[data-gc-qo-results]');
  var stateEl = root.querySelector('[data-gc-qo-state]');
  var searchInput = root.querySelector('[data-gc-qo-search]');
  var clearBtn = root.querySelector('[data-gc-qo-clear]');
  var tray = root.querySelector('[data-gc-qo-tray]');
  var trayLines = root.querySelector('[data-gc-qo-lines]');
  var trayUnits = root.querySelector('[data-gc-qo-units]');
  var trayAdd = root.querySelector('[data-gc-qo-tray-add]');
  var trayClear = root.querySelector('[data-gc-qo-tray-clear]');
  var trayError = root.querySelector('[data-gc-qo-tray-error]');
  if (!results) { return; }

  var ALL_URL = root.getAttribute('data-all-url') || '/collections/all';
  var SEARCH_URL = root.getAttribute('data-search-url') || '/search';
  var CART_ADD_URL = root.getAttribute('data-cart-add-url') || '/cart/add';
  var LIST_VIEW = 'quickorder';
  var VARIANT_VIEW = 'qovariants'; /* gcSkuLookup */
  var MODEL_MAP = {
    'iphone 17 pro max':'17PM','iphone 17 pro':'17PR','iphone 17e':'17E','iphone 17':'17','iphone air':'AIR',
    'iphone 16 pro max':'16PM','iphone 16 pro':'16PR','iphone 16 plus':'16PL','iphone 16e':'16E','iphone 16':'16',
    'iphone 15 pro max':'15PM','iphone 15 pro':'15PR','iphone 15 plus':'15PL','iphone 15':'15',
    'iphone 14 pro max':'14PM','iphone 14 pro':'14PR','iphone 14 plus':'14PL','iphone 14':'14',
    'iphone 13 pro max':'13PM','iphone 13 pro':'13PR','iphone 13 mini':'13MN','iphone 13':'13',
    'iphone 12 pro max':'12PM','iphone 12 pro':'12PR','iphone 12 mini':'12MN','iphone 12':'12',
    'iphone 11 pro max':'11PM','iphone 11 pro':'11PR','iphone 11':'11','iphone xr':'XR'
  };
  var MODELS = (function () {
    try { var el = root.querySelector('[data-gc-qo-models]'); return el ? JSON.parse(el.textContent) : []; }
    catch (e) { return []; }
  })();
  function titleModelCode(title) {
    var t = String(title || '')
      .replace(/\s*UNLOCKED\s*/i, ' ')
      .replace(/\s*\(.*?\)\s*/g, ' ')
      .replace(/[\u2014\u2013-]\s*Brand\s*New/i, ' ')
      .replace(/\bBrand\s*New\b/i, ' ')
      .replace(/\s+\d+\s*(gb|tb)\b/i, ' ')
      .replace(/\s+/g, ' ').trim().toLowerCase();
    var keys = Object.keys(MODEL_MAP).sort(function (a, b) { return b.length - a.length; });
    var i;
    for (i = 0; i < keys.length; i++) { if (t === keys[i]) { return MODEL_MAP[keys[i]]; } }
    for (i = 0; i < keys.length; i++) { if (t.indexOf(keys[i]) === 0) { return MODEL_MAP[keys[i]]; } }
    return null;
  }
  var CODE_TO_HANDLES = (function () {
    var m = {}, i, code;
    for (i = 0; i < MODELS.length; i++) {
      code = titleModelCode(MODELS[i].t);
      if (!code) { continue; }
      if (!m[code]) { m[code] = []; }
      m[code].push(MODELS[i].h);
    }
    return m;
  })();
  function skuQuery() {
    var raw = searchInput ? (searchInput.value || '') : '';
    var clean = raw.replace(/\s+/g, '').toUpperCase();
    if (!/^GC-IP[A-Z0-9]+/.test(clean)) { return null; }
    var parts = clean.split('-');
    if (parts.length < 2) { return null; }
    var code = parts[1].replace(/^IP/, '');
    var handles = CODE_TO_HANDLES[code];
    if (!handles || !handles.length) { return { sku: clean, handles: [], unknown: true }; }
    return { sku: clean, handles: handles };
  }
  function filterRowsBySku(sku) {
    var needle = String(sku || '').toLowerCase();
    var rows = results.querySelectorAll('[data-gc-row]');
    var shown = 0, i, s;
    for (i = 0; i < rows.length; i++) {
      s = (rows[i].getAttribute('data-sku') || '').toLowerCase();
      if (s && s.indexOf(needle) === 0) { rows[i].removeAttribute('hidden'); shown++; }
      else { rows[i].setAttribute('hidden', ''); }
    }
    var tables = results.querySelectorAll('.gc-qov');
    for (i = 0; i < tables.length; i++) {
      if (tables[i].querySelectorAll('[data-gc-row]:not([hidden])').length === 0) { tables[i].setAttribute('hidden', ''); }
      else { tables[i].removeAttribute('hidden'); }
    }
    return shown;
  }
  function loadSkuView(target) {
    var mine = ++token;
    if (target.unknown) {
      results.innerHTML = '';
      setState('No model matches that SKU prefix. Check the code, or search by model name.', true);
      return Promise.resolve();
    }
    results.setAttribute('aria-busy', 'true');
    setState('Looking up ' + target.sku);
    var urls = target.handles.map(function (h) { return '/products/' + h + '?view=' + VARIANT_VIEW; });
    return Promise.all(urls.map(function (u) { return fetchText(u).catch(function () { return ''; }); })).then(function (parts) {
      if (mine !== token) { return; }
      results.innerHTML = parts.join('');
      results.removeAttribute('aria-busy');
      if (results.querySelector('[data-gc-qo-denied], .gc-qov__denied')) { setState('This account is not authorised for Quick Order.', true); return; }
      var shown = filterRowsBySku(target.sku);
      if (shown === 0) { setState('No SKU starts with ' + target.sku + '.', true); }
      else { setState(shown === 1 ? '1 SKU matches ' + target.sku : shown + ' SKUs match ' + target.sku); }
    }).catch(function () {
      if (mine !== token) { return; }
      results.removeAttribute('aria-busy');
      setState('We could not look up that SKU. Check your connection and try again.', true);
    });
  }
  function refresh() {
    var t = skuQuery();
    return t ? loadSkuView(t) : loadList(listUrl());
  }
  var VARIANT_VIEW = 'qovariants';

  var selection = {};
  var token = 0;
  var debounce = null;

  function setState(msg, isError) {
    if (!stateEl) { return; }
    stateEl.textContent = msg || '';
    if (isError) { stateEl.classList.add('gc-qo__state--error'); }
    else { stateEl.classList.remove('gc-qo__state--error'); }
  }

  function listUrl() {
    var q = searchInput ? (searchInput.value || '').trim() : '';
    var u;
    if (q) {
      u = new URL(SEARCH_URL, window.location.origin);
      u.searchParams.set('q', q);
      u.searchParams.set('type', 'product');
      u.searchParams.set('options[prefix]', 'last');
    } else {
      u = new URL(ALL_URL, window.location.origin);
    }
    u.searchParams.set('view', LIST_VIEW);
    return u;
  }

  function activeFacets() {
    var out = [];
    var sels = results.querySelectorAll('[data-gc-qo-filter]');
    for (var i = 0; i < sels.length; i++) {
      if (sels[i].value) { out.push([sels[i].getAttribute('data-param'), sels[i].value]); }
    }
    return out;
  }

  function urlWithFacets(facets) {
    var u = listUrl();
    for (var i = 0; i < facets.length; i++) { u.searchParams.append(facets[i][0], facets[i][1]); }
    return u;
  }

  function selectedOptionValues() {
    var vals = [];
    var sels = results.querySelectorAll('[data-gc-qo-filter]');
    for (var i = 0; i < sels.length; i++) {
      var p = sels[i].getAttribute('data-param') || '';
      if (p.indexOf('filter.v.option.') === 0 && sels[i].value) { vals.push(sels[i].value); }
    }
    return vals;
  }

  function fetchText(url) {
    return fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) { throw new Error('HTTP ' + r.status); }
        return r.text();
      });
  }

  function loadList(url) {
    var mine = ++token;
    results.setAttribute('aria-busy', 'true');
    setState('Loading inventory');
    return fetchText(url.toString()).then(function (html) {
      if (mine !== token) { return; }
      results.innerHTML = html;
      results.removeAttribute('aria-busy');
      var c = results.querySelector('.gc-qor__count');
      setState(c ? c.textContent : '');
      if (results.querySelector('[data-gc-qo-denied]')) { setState('Account not authorised for Quick Order.', true); }
    }).catch(function () {
      if (mine !== token) { return; }
      results.removeAttribute('aria-busy');
      setState('We could not load inventory. Check your connection and try again.', true);
    });
  }

  function applyRowFilters(scope) {
    var wanted = selectedOptionValues();
    var rows = (scope || results).querySelectorAll('[data-gc-row]');
    for (var i = 0; i < rows.length; i++) {
      var opts = rows[i].getAttribute('data-opts') || '';
      var show = true;
      for (var j = 0; j < wanted.length; j++) {
        if (opts.split('||').indexOf(wanted[j]) === -1) { show = false; break; }
      }
      if (show) { rows[i].removeAttribute('hidden'); } else { rows[i].setAttribute('hidden', ''); }
    }
  }

  function restoreQty(scope) {
    var inputs = (scope || results).querySelectorAll('[data-gc-qty]');
    for (var i = 0; i < inputs.length; i++) {
      var id = inputs[i].getAttribute('data-variant');
      if (selection[id]) { inputs[i].value = selection[id]; markRow(inputs[i], true); }
    }
  }

  function markRow(input, on) {
    var row = input.closest('[data-gc-row]');
    if (!row) { return; }
    if (on) { row.classList.add('is-selected'); } else { row.classList.remove('is-selected'); }
  }

  function updateTray() {
    var lines = 0, units = 0;
    for (var k in selection) {
      if (selection[k] > 0) { lines++; units += selection[k]; }
    }
    if (trayLines) { trayLines.textContent = String(lines); }
    if (trayUnits) { trayUnits.textContent = String(units); }
    if (tray) {
      if (lines > 0) { tray.removeAttribute('hidden'); } else { tray.setAttribute('hidden', ''); }
    }
    if (trayError) { trayError.setAttribute('hidden', ''); trayError.textContent = ''; }
  }

  function normalise(input) {
    var min = parseInt(input.getAttribute('data-min'), 10) || 1;
    var step = parseInt(input.getAttribute('data-step'), 10) || 1;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val <= 0) { return 0; }
    if (val < min) { val = min; }
    if (step > 1) {
      var over = (val - min) % step;
      if (over !== 0) { val = val + (step - over); }
    }
    return val;
  }

  function togglePanel(article) {
    var panel = article.querySelector('[data-gc-model-panel]');
    var btn = article.querySelector('[data-gc-model-toggle]');
    if (!panel || !btn) { return; }
    var open = article.getAttribute('data-open') === 'true';
    if (open) {
      article.setAttribute('data-open', 'false');
      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
      return;
    }
    article.setAttribute('data-open', 'true');
    btn.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
    if (article.getAttribute('data-loaded') === 'true') { applyRowFilters(panel); return; }
    panel.innerHTML = '<p class="gc-qom__loading">Loading variants and your account pricing</p>';
    var u = new URL('/products/' + article.getAttribute('data-handle'), window.location.origin);
    u.searchParams.set('view', VARIANT_VIEW);
    fetchText(u.toString()).then(function (html) {
      panel.innerHTML = html;
      article.setAttribute('data-loaded', 'true');
      applyRowFilters(panel);
      restoreQty(panel);
    }).catch(function () {
      panel.innerHTML = '<p class="gc-qom__loading">Unable to load this model. Please try again.</p>';
    });
  }

  results.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-gc-model-toggle]');
    if (toggle) { e.preventDefault(); togglePanel(toggle.closest('[data-gc-model]')); return; }
    var pager = e.target.closest('[data-gc-qo-page]');
    if (pager) { e.preventDefault(); loadList(new URL(pager.getAttribute('href'), window.location.origin)); return; }
    var reset = e.target.closest('[data-gc-qo-reset]');
    if (reset) { e.preventDefault(); refresh(); return; }
  });

  results.addEventListener('change', function (e) {
    if (e.target.matches('[data-gc-qo-filter]')) { loadList(urlWithFacets(activeFacets())); }
  });

  results.addEventListener('input', function (e) {
    if (!e.target.matches('[data-gc-qty]')) { return; }
    var id = e.target.getAttribute('data-variant');
    var val = parseInt(e.target.value, 10);
    if (isNaN(val) || val <= 0) { delete selection[id]; markRow(e.target, false); }
    else { selection[id] = val; markRow(e.target, true); }
    updateTray();
  });

  results.addEventListener('blur', function (e) {
    if (!e.target.matches || !e.target.matches('[data-gc-qty]')) { return; }
    var id = e.target.getAttribute('data-variant');
    var val = normalise(e.target);
    if (val > 0) { e.target.value = val; selection[id] = val; markRow(e.target, true); }
    else { e.target.value = ''; delete selection[id]; markRow(e.target, false); }
    updateTray();
  }, true);

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      if (clearBtn) {
        if (searchInput.value) { clearBtn.removeAttribute('hidden'); } else { clearBtn.setAttribute('hidden', ''); }
      }
      window.clearTimeout(debounce);
      debounce = window.setTimeout(function () { refresh(); }, 320);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); window.clearTimeout(debounce); refresh(); }
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      searchInput.value = '';
      clearBtn.setAttribute('hidden', '');
      refresh();
    });
  }

  if (trayClear) {
    trayClear.addEventListener('click', function () {
      selection = {};
      var inputs = results.querySelectorAll('[data-gc-qty]');
      for (var i = 0; i < inputs.length; i++) { inputs[i].value = ''; markRow(inputs[i], false); }
      updateTray();
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll('[data-gc-cart-count]');
        for (var i = 0; i < nodes.length; i++) { nodes[i].textContent = cart.item_count; }
      })
      .catch(function () {});
  }

  if (trayAdd) {
    trayAdd.addEventListener('click', function () {
      var items = [];
      for (var k in selection) {
        if (selection[k] > 0) { items.push({ id: parseInt(k, 10), quantity: selection[k] }); }
      }
      if (!items.length) { return; }
      trayAdd.disabled = true;
      trayAdd.textContent = 'Adding';
      if (trayError) { trayError.setAttribute('hidden', ''); }
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        trayAdd.disabled = false;
        trayAdd.textContent = 'Add to cart';
        if (!res.ok) {
          if (trayError) {
            trayError.textContent = (res.data && res.data.description) ? res.data.description : 'Some items could not be added. Check quantities and availability.';
            trayError.removeAttribute('hidden');
          }
          return;
        }
        selection = {};
        var inputs = results.querySelectorAll('[data-gc-qty]');
        for (var i = 0; i < inputs.length; i++) { inputs[i].value = ''; markRow(inputs[i], false); }
        updateTray();
        setState('Added to cart. Pricing is confirmed by Shopify in cart and checkout.');
        refreshCartCount();
      }).catch(function () {
        trayAdd.disabled = false;
        trayAdd.textContent = 'Add to cart';
        if (trayError) { trayError.textContent = 'We could not reach the cart. Please try again.'; trayError.removeAttribute('hidden'); }
      });
    });
  }

  refresh();
})();